/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import hmiIcon from '@/assets/personal.png'
import ptcLogo from '@/assets/ptc/PTC_logo.svg'

function HmiBottomNode({ data, isConnectable }) {
  const hmiLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return ptcLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return ptcLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return ptcLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return ptcLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={hmiLogo()} alt="HMI Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>HMI</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Bottom} />
      <Handle type="source" position={Position.Bottom} />
    </div>
  )
}

export default HmiBottomNode
